import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetBeacon4BlendedSeries } from '../requests/Beacon4PerformanceRequests';

export const loadBeacon4BlendedSeries = createAsyncThunk(
	'beacon4KpiData/loadBlendedSeries',
	async (params, { rejectWithValue }) => {
		try {
			const res = await GetBeacon4BlendedSeries(params);
			return res?.data ?? res;
		} catch (e) {
			return rejectWithValue(e.response?.data ?? e.message);
		}
	}
);

const beacon4KpiDataSlice = createSlice({
	name: 'beacon4KpiData',
	initialState: {
		blendedSeries: {},   // { [kpiKey]: KpiSeriesDto }
		loading:       false,
		loadingCount:  0,    // track parallel requests
		error:         null,
	},
	reducers: {
		clearBeacon4BlendedSeries(state) {
			state.blendedSeries = {};
			state.loading       = false;
			state.loadingCount  = 0;
			state.error         = null;
		},
	},
	extraReducers: (b) => {
		b.addCase(loadBeacon4BlendedSeries.pending, (s) => {
			s.loadingCount += 1;
			s.loading       = true;
			s.error         = null;
		})
			.addCase(loadBeacon4BlendedSeries.fulfilled, (s, a) => {
				s.loadingCount -= 1;
				s.loading       = s.loadingCount > 0;
				if (a.payload?.kpiKey) s.blendedSeries[a.payload.kpiKey] = a.payload;
			})
			.addCase(loadBeacon4BlendedSeries.rejected, (s, a) => {
				s.loadingCount -= 1;
				s.loading       = s.loadingCount > 0;
				s.error         = a.payload;
			});
	},
});

export const { clearBeacon4BlendedSeries } = beacon4KpiDataSlice.actions;
export default beacon4KpiDataSlice.reducer;

export const selectBeacon4BlendedSeries = (state) => state.beacon4KpiData.blendedSeries;
export const selectBeacon4KpiLoading    = (state) => state.beacon4KpiData.loading;